"use strict";

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkP4KLBECRjs = require('./chunk-P4KLBECR.js');

var _chunkR4XHR6A7js = require('./chunk-R4XHR6A7.js');

var _styledcomponents = require('styled-components');

var i = function i(e) {
  return _styledcomponents.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    font-style: ", ";\n    font-weight: ", ";\n    letter-spacing: ", ";\n    line-height: ", ";\n    ", "\n"])), e.family, e.size, e.style, e.weight, e.spacing, e.height, e.transform && _styledcomponents.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        text-transform: ", ";\n    "])), e.transform));
},
    c = exports.a = function (_ref) {
  var e = _ref.$forceMobile,
      r = _ref.$typographySpecKey,
      a = _ref.theme;

  var p = _chunkR4XHR6A7js.a.call(void 0, a.typography, r),
      o = p.mobile;

  return e ? _styledcomponents.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            ", "\n        "])), i(o)) : _styledcomponents.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        ", "\n\n        ", "\n    "])), i(p), !!o && _chunkP4KLBECRjs.b.call(void 0, "xs", i(o)));
};

exports.a = c;